import { PDFDocument } from "pdf-lib";

export const getPageCount = async (url) => {
  try {
    const response = await fetch(url);
    const pdfData = await response.arrayBuffer();
    const pdfDoc = await PDFDocument.load(pdfData);
    return pdfDoc.getPageCount();
  } catch (error) {
    console.error("Error loading PDF:", error);
  }
};
